import { Tag } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

export const ContactKindTag = ({ kind, size }: { kind: "withAccount" | "addedByYou"; size?: "sm" | "md" | "lg" }) => {
  const { t } = useTranslation();
  const meta =
    kind === "withAccount"
      ? { color: "blue", text: t("User with account") }
      : { color: "gray", text: t("Added by your organization") };
  return (
    <Tag colorScheme={meta.color} size={size} textAlign="center" variant="outline" py="0.5" whiteSpace="nowrap">
      {meta.text}
    </Tag>
  );
};
